export default "__VITE_ASSET__0b9e88d8__"